import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import { MessageBox } from 'element-ui'
import Cookies from 'js-cookie'
import qs from "qs";
import axios from "axios";
import api from "@/config/apis.js";


Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    alias: '/',
    component: () => import('@/views/home/home.vue')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('@/views/info/info.vue')
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/views/activity/act.vue')
  },
  {
    path: '/channel',
    name: 'channel',
    component: () => import('@/views/channel/channel.vue')
  },
  {
    path: '/member',
    name: 'member',
    component: () => import('@/views/member/member.vue')
  },
  {
    path: '/organization',
    name: 'organization',
    component: () => import('@/views/organization/organization.vue')
  },
  {
    path: '/points-mall',
    name: 'points-mall',
    component: () => import('@/views/points-mall/points-mall.vue')
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('@/views/my/my.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/search/index.vue')
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('@/views/course/course.vue')
  },
  {
    path: '/ccourse',
    name: 'ccourse',
    component: () => import('@/views/course/ccourse.vue')
  },
  {
    path: '/alliance',
    name: 'alliance',
    component: () => import('@/views/alliance/alliance.vue')
  }
]

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
	return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior () {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0, behavior: 'smooth' }
  },
  routes
})

function getParameter(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构建一个含有目标参数的正则表达式对象
	var r = window.location.search.substr(1).match(reg); //匹配目标参数
	if (r != null) {
		return unescape(r[2]); //返回参数值
	}
	return null;
}

async function isLogin(ticket) {
	let login = {
		ticket,
		service: api.location_host,
		grant_type: "pc",
	};

	axios({
		url: `${api.apiUrl}/auth/oauth/token`,
		method: "post",
		data: qs.stringify(login),
		headers: {
			"content-type": "application/x-www-form-urlencoded",
			Authorization: "Basic cmVucmVuaW86cmVucmVuaW8=",
		},
	}).then(function(res) {
    Cookies.set("access_token", res.data.access_token);
		axios({
			url: `${api.apiUrl}/sys/user/info`,
			method: "get",
			headers: {
				Authorization: "Bearer " + res.data.access_token || "",
			},
		})
			.then(({ data: resInfo }) => {
				if (resInfo.code !== 0) {
          MessageBox.confirm('抱歉！您的帐号异常，请联系平台管理员', '提示', {
            type: 'error'
          })
					return console.error("login err:", resInfo.msg);
				}
        store.commit("user/setUserInfo", resInfo.data);
			})
			.catch((err) => {
				console.error("login catch err:", err);
			});
	});

	return;
}

router.beforeEach((to, from, next) => {
  let ticket = getParameter("code") || "";
  // 登录拦截
  if (['/my'].includes(to.path) && !ticket) {
    if (!to.query.uid && !(Cookies.get('access_token') || store.state.user.id)) {
      // Message.warning('请先登录')
      // return next('/')
      location.href = api.BaseSSOUrl + api.SSOUrl  + encodeURIComponent(api.location_host)
    }
  }

	if (ticket && !(Cookies.get('access_token') || store.state.user.id)) {
		isLogin(ticket);
	}
  next()
})

export default router
